import { render, staticRenderFns } from "./PrintConsentCancerForm.vue?vue&type=template&id=cf41b98c&scoped=true"
import script from "./PrintConsentCancerForm.vue?vue&type=script&lang=js"
export * from "./PrintConsentCancerForm.vue?vue&type=script&lang=js"
import style0 from "./PrintConsentCancerForm.vue?vue&type=style&index=0&id=cf41b98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf41b98c",
  null
  
)

export default component.exports